
import React from "react";
import Background from "./Background";

function Layout({ children }) {
  return (
    <>
      <Background />
      <div className="page-content">{children}</div>
    </>
  );
}

export default Layout;
